const custom_reports = [];

const app = {
    name: 'Concierge',
    title: 'PlaceOS',
    description: 'Concierge UI',
    short_name: 'PlaceOS',
    logo_light: 'assets/logo-light.svg',
    logo_dark: 'assets/logo-dark.svg',
    default_route: '/book/rooms',
    use_24_hour_time: false,
    use_region: true,
    admin_group: 'concierge_admins',
    features: [
        'spaces',
        'zones',
        'desks',
        'parking',
        'visitors',
        'assets',
        'facilities',
        'internal-users',
        'points',
        'surveys',
        'catering',
        'events',
        'booking-report',
        'contact-tracing-report',
        'signage',
        'events',
        'email-templates',
        'services',
    ],
    guests: { vaccine_check: true },
    delegated: false,
    has_uploads: true,
    custom_reports,
    desks: { can_book_for_others: true },
    bookings: { can_book_for_others: true, use_building_timezone: false },
    events: {
        allow_setup_breakdown: false,
        use_building_timezone: false,
        block_start: 7,
        block_end: 19,
        block_height: 5,
        custom_actions: [
            {
                id: 'set_setup_breakdown',
                name: 'Set Setup/Breakdown',
                icon: 'manage_history',
            },
        ],
    },
    locales: [
        { id: 'en-AU', name: 'LANGUAGE.ENGLISH', local: 'English', flag: '🇦🇺' },
        {
            id: 'en-US',
            name: 'LANGUAGE.ENGLISH_US',
            local: 'English (US)',
            flag: '🇺🇸',
        },
        { id: 'fr', name: 'LANGUAGE.FRENCH', local: 'Français', flag: '🇫🇷' },
        {
            id: 'fr-CA',
            name: 'LANGUAGE.FRENCH_CA',
            local: 'Français (Canada)',
            flag: '🇨🇦',
        },
        { id: 'es', name: 'LANGUAGE.SPANISH', local: 'Español', flag: '🇪🇸' },
        {
            id: 'pt',
            name: 'LANGUAGE.PORTUGESE',
            local: 'Português',
            flag: '🇵🇹',
        },
        { id: 'it', name: 'LANGUAGE.ITALIAN', local: 'Italiano', flag: '🇮🇹' },
        { id: 'zh', name: 'LANGUAGE.CHINESE', local: '中文', flag: '🇨🇳' },
        { id: 'ja-JP', name: 'LANGUAGE.JAPANESE', local: '日本語', flag: '🇯🇵' },
        { id: 'ar', name: 'LANGUAGE.ARABIC', local: 'عربية', flag: '' },
    ],
    catering: {
        use_bookings: true,
    },
};

/**
 * ROOT SETTIGNS
 */
export const DEFAULT_SETTINGS: any = {
    debug: true,
    mock: true,
    composer: {
        domain: '',
        route: '/concierge',
        protocol: '',
        port: '',
        use_domain: false,
        local_login: false,
    },
    app,
};
